var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:currentColor;stroke:currentColor;stroke-width:2px}.cls-3{stroke:none}.cls-4{fill:none}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "book_32dp",
    transform: "translate(-788 -66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "frame",
    transform: "translate(788 66)",
    style: {
      fill: "transparent"
    },
    d: "M0 0h24v24H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(791 69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17888",
    "data-name": "Rectangle 17888",
    className: "cls-2",
    transform: "rotate(-4.01 42.234 -154.72)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 5.03,
    height: 15.072,
    rx: 2.515
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 3.03,
    height: 13.072,
    rx: 1.515
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17885",
    "data-name": "Rectangle 17885",
    className: "cls-2",
    transform: "translate(5.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 5.03,
    height: 17.484,
    rx: 2.515
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 3.03,
    height: 15.484,
    rx: 1.515
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17887",
    "data-name": "Rectangle 17887",
    className: "cls-2",
    transform: "translate(0 5.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 5.03,
    height: 12.058,
    rx: 2.515
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 3.03,
    height: 10.058,
    rx: 1.515
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.eb24353ec7d9bbf2ac5eff84f271e54e.svg";
export { ForwardRef as ReactComponent };